import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
  SuiModalService,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { AolService } from 'src/modules/features/contractor/services';
import { LinkDocumentModal } from 'src/modules/features/contractor/modals';
import { PdfViewerService } from 'src/modules/features/contractor/services/pdfViewer';
import { ConfirmModal } from '../confirm-modal/confirm-modal.component';
interface IChatDocumentModalContext {
  data: any;
  title?: string;
  edit?: any;
}

interface Document {
  documentTypeId: string;
  documentTypeName: string;
  isRequired: boolean;
  isActive: boolean;
  dateCreated: string;
  dateModified: string;
  group: any;
  createdBy: string;
  modifiedBy: string;
  uploadedFiles?: File[];
}
@Component({
  selector: 'app-chat-document-modal',
  templateUrl: './chat-document-modal.component.html',
  styleUrls: ['./chat-document-modal.component.scss'],
})
export class ChatDocumentModalComponent implements OnInit, OnDestroy {
  options = [];
  documentsType: any;
  searchable: boolean = true;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;
  selectedFile;
  replyForm: FormGroup;
  documents: Array<any> = [];
  fileError;
  requireDocs = [];
  isRequired: boolean = false;
  name: string;
  fileName: any;
  wordings: string =
    'Please note: Any changes made here will be verified before it appears on your profile';
  documentName: string = '';
  documentss: Document[];
  firstShow: boolean = false;
  secondShow: boolean = false;
  editName() {
    this.firstShow = false;
    this.secondShow = true;
  }
  onDocumentNameChange(value) {}
  saveName() {
    this.revert();
  }
  revert() {
    this.firstShow = true;
    this.secondShow = false;
  }
  onFileChanges(event: any, document: Document): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const uploadedFiles: File[] = Array.from(fileList);
      document.uploadedFiles = document.uploadedFiles || [];
      document.uploadedFiles = [...document.uploadedFiles, ...uploadedFiles];
    }
    this.uploadedDocuments = this.documentss
      .filter((doc) => doc.uploadedFiles && doc.uploadedFiles.length > 0)
      .map(({ uploadedFiles, ...rest }) => ({ ...rest, uploadedFiles }));
  }
  uploadedDocuments: any = [];
  removeDocument(index: number): void {
    this.documentss.splice(index, 1);
  }

  removeFile(document: Document, fileIndex: number): void {
    if (document.uploadedFiles) {
      document.uploadedFiles.splice(fileIndex, 1);
    }
  }
  removeLinkedDocument(doc, index) {
    if (doc) {
      this.allLinkedDocuments.splice(index, 1);
    }
  }
  editLinkedDocument(doc, index, data) {
    this.modalService
      .open(
        new LinkDocumentModal(
          `Edit Selected existing documents from ${data} Document Type`,
          doc,
          data,
          this.uploads,
          ModalSize.Tiny
        )
      )
      .onApprove((documents: any) => {
        console.log(documents, 'doc');
        if (doc) {
          this.allLinkedDocuments[index] = documents[0];
        }
      })
      .onDeny(() => {});
  }
  editFile(event: any, document: Document, fileIndex: number): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const newFile: File = fileList[0];

      // Replace the existing file at the specified index
      if (document.uploadedFiles && document.uploadedFiles[fileIndex]) {
        document.uploadedFiles[fileIndex] = newFile;
      }
    }
  }

  onSubmit(): void {
    // Collect the uploaded documents for submission
    const uploadedDocuments = this.documentss.filter(
      (doc) => doc.uploadedFiles
    );

    // Send the uploadedDocuments array to your backend for further processing
    console.log('Uploaded Documents:', uploadedDocuments);
  }
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<IChatDocumentModalContext, void, void>,
    private aolService: AolService,
    private modalService: SuiModalService,
    private pdfViewerService: PdfViewerService
  ) {
    this.documentsType = modal.context.data;
    console.log(this.documentsType, 'new to me');
    this.name = this.documentsType['documentTypeName'];
    this.isRequired = this.documentsType['isRequired'];
    this.replyForm = fb.group({
      documentTypeId: [
        this.documentsType['documentTypeId'],
        Validators.required,
      ],
      documentTypeName: [
        this.documentsType['documentTypeName'],
        Validators.required,
      ],
      documentName: [
        this.documentsType['documentTypeName'],
        Validators.required,
      ],
      document: ['', Validators.required],
      attachment: [true],
      documentDescription: ['string'],
    });
    if (modal.context.edit) {
      console.log(modal.context.edit, modal.context.data);
      this.uploadedFiles.push(modal.context.edit);
      this.replyForm.patchValue({
        documentName: modal.context.edit.documentId.documentName,
      });
      this.firstShow = true;
    }
    // this.getDocumentUploaded();
  }

  allLinkedDocuments: any = [];
  LinkDocument(data) {
    this.modalService
      .open(
        new LinkDocumentModal(
          `Select and link existing documents from ${data} Document Type`,
          '',
          data,
          this.uploads,
          ModalSize.Tiny
        )
      )
      .onApprove((documents: any) => {
        console.log(documents, 'doc');
        documents.map((item) => this.allLinkedDocuments.push(item));
      })
      .onDeny(() => {});
  }
  viewFiles(file): void {
    if (this.modal.context.edit) {
      if (file.documentId.extension == 'image') {
        this.pdfViewerService.viewPdf(file.documentId, 'image');
        // url = `${this.baseUrl}/public/image/?media=${payload.documentId.documentPath}`;
      } else {
        this.pdfViewerService.viewPdf(file.documentId);
      }
    } else {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const blob = new Blob([e.target.result], { type: file.type });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
      };
      reader.readAsArrayBuffer(file);
    }
    // Use readAsArrayBuffer for binary data
  }
  removeFileNew(fileIndex: number): void {
    if (this.uploadedFiles) {
      this.uploadedFiles.splice(fileIndex, 1);
      this.selectedFile = null;
      this.fileName = null;
    }
  }
  returnDocumentType(data, id) {
    const filtered = data.filter((item) => {
      return item.documentTypeId.documentTypeName === id;
    });
    return filtered;
  }

  uploads: any = [];
  getDocumentUploaded() {
    this.pending = true;
    this.aolService
      .getDocumentUpload({
        optionId: 'official_documents',
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.uploads = res.filter((item) => item.isActive);
          console.log(this.uploads, 'this.uploads');
          this.documentss = this.uploads.map((doc) => ({
            ...doc,
            uploadedFiles: [],
          }));
          console.log(this.documentss, 'document');
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
  }
  isFieldValid(field: string) {
    return (
      (!this.replyForm.get(field).valid && this.replyForm.get(field).touched) ||
      (this.replyForm.get(field).untouched && this.formSubmitAttempt)
    );
  }
  uploadedFiles = [];
  onFileChange(event) {
    const files = event.target.files;
    if (!files) {
      return;
    }
    if (files.length > 0) {
      const uploadedFiles: File[] = Array.from(files);
      this.uploadedFiles = this.uploadedFiles || [];
      this.uploadedFiles = [...this.uploadedFiles, ...uploadedFiles];
    }
    this.selectedFile = files[0];
    this.fileName = this.selectedFile['name'];
    this.firstShow = true;
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

  save() {
    this.modalService
      .open(
        new ConfirmModal(
          `Upload Document `,
          `Are you sure you want to Upload this document? `,
          ModalSize.Mini,
          'Yes, Upload',
          'Cancel'
        )
      )
      .onApprove(() => {
        this.formSubmitAttempt = false;
        if (this.fileError == null) {
          let data: any = this.replyForm.value;
          const formData: FormData = new FormData();
          formData.append('file', this.selectedFile, this.selectedFile.name);
          let payload: any = { formValue: data, formData: formData };
          this.modal.approve(payload);
        } else {
          this.formSubmitAttempt = true;
        }
      });
  }
  nullify() {
    this.success = null;
    this.error = null;
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
}

export class ChatDocumentModal extends ComponentModalConfig<
  IChatDocumentModalContext,
  void,
  void
> {
  constructor(
    title: string,
    data: any,
    edit?: any,
    size: ModalSize = ModalSize.Mini
  ) {
    super(ChatDocumentModalComponent, { title, data, edit });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
